import React from 'react';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { Dependent, DependentTypes } from '../../dependents/dependents-model';
import { DependentDisplay } from './dependent-display';

interface Props {
	dependents: Dependent[];
	noDependentsFoundMessage: string;
	basePath: string;
	dependentType: DependentTypes;
}
export function DependentsDisplay(props: Props) {
	const { dependents, basePath, dependentType } = props;

	function hasDependents() {
		return dependents?.length > 0;
	}

	return (
		<>
			{hasDependents()
				? dependents?.map(dependent => {
					return (
						<ContentSpacer key={`d-${dependent.client_nbr || `${dependent.first_name?.trim()}${dependent.last_name?.trim()}`}`} >
							<DependentDisplay dependent={dependent} dependentType={dependentType} basePath={basePath} />
						</ContentSpacer>
					);
				})
				: dependentType === DependentTypes.child && <ContentSpacer><div dangerouslySetInnerHTML={{ __html: props.noDependentsFoundMessage }} /></ContentSpacer>}
		</>

	);
}